var jingdian = [
    // —————— 朝阳区 ——————
    [125.348749, 43.905618, '伪满皇宫博物院'],
    [125.351261, 43.887011, '长春文庙'],
    [125.307823, 43.882416, '吉林大学地质博物馆'],
    [125.292701, 43.866797, '这有山（室内文旅商业综合体）'],
    [125.296390, 43.867182, '红旗街万达广场·室内儿童乐园'],

    // —————— 南关区 ——————
    [125.333336, 43.823572, '长春世界雕塑园'],
    [125.332001, 43.864296, '长春动植物公园'],
    [125.306789, 43.856452, '南湖公园'],
    [125.432919, 43.829554, '吉林省自然博物馆'],
    [125.292355, 43.863640, '长影旧址博物馆'],
    [125.292388, 43.865153, '长春电影制片厂厂区'],

    // —————— 宽城区 ——————
    [125.233844, 43.852538, '长春北湖国家湿地公园'],
    [125.409669, 44.000267, '长春奥林匹克公园'],
    [124.865901, 43.340439, '长春东北民族民俗博物馆'],
    [125.323643, 43.816996, '长春市规划展览馆'],

    // —————— 二道区 ——————
    [125.746687, 43.861025, '长春莲花山滑雪场'],
    [125.546194, 43.885940, '莲花山生态旅游度假区'],
    [125.421724, 43.809602, '劝农山农业博览园'],
    [125.409845, 43.639662, '慢山里营地综合体'],

    // —————— 绿园区 ——————
    [125.176229, 43.828471, '长春国际汽车公园'],
    [125.323643, 43.816996, '长春皓月清真寺'],
    [125.323643, 43.816996, '长春和平公园'],

    // —————— 双阳区 ——————
    [125.864304, 43.348254, '神鹿峰旅游度假区'],
    [125.705391, 43.596307, '御龙温泉度假村'],
    [125.889483, 43.366156, '吊水壶溶洞风景区'],
    [125.723985, 43.536878, '双阳湖风景区'],
    [125.528192, 43.685738, '国信南山温泉度假酒店'],
    [125.519115, 43.691065, '奢岭草莓采摘园'],

    // —————— 九台区 ——————
    [125.887675, 43.960525, '庙香山温泉滑雪度假区'],
    [125.527199, 43.442039, '马鞍山田园综合体'],
    [125.870924, 43.890005, '波泥河苗木花卉产业园'],
    [125.542909, 43.882489, '卡伦湖旅游度假区'],
    [126.340140, 44.368755, '其塔木镇稻梦空间'],

    // —————— 农安县 ——————
    [125.542909, 43.882489, '剑鹏马城国际旅游度假区'],
    [125.697452, 43.801805, '太平池生态旅游度假区'],

    // —————— 榆树市 ——————
    [126.297209, 44.799138, '榆树市刘家镇生态农业观光园'],
    [126.475073, 44.608102, '大坡镇绿色蔬菜基地'],
    [125.233844, 43.852538, '秀水镇湿地公园'],

    // —————— 德惠市 ——————
    [125.888083, 44.812615, '德惠松花江大桥湿地公园'],
    [125.759931, 44.389303, '布海镇香瓜采摘园'],
    [125.570884, 44.290606, '朱城子镇现代农业示范园'],

    // —————— 长春新区 & 经开区 ——————
    [125.394548, 43.838617, '长春国际会展中心'],
    [125.434360, 43.769379, '长春科技文化中心'],
    [125.584086, 43.878286, '长春冰雪新天地（冬季限定）'],

    // —————— 亲子乐园 & 儿童友好型重点景区 ——————
    [125.292701, 43.866797, '这有山（室内山景+儿童游乐+研学体验）'],
    [125.864304, 43.348254, '神鹿峰旅游度假区（玻璃栈道+萌宠乐园+无动力设施）'],
    [125.333336, 43.823572, '长春世界雕塑园（儿童互动雕塑区）'],
    [125.332001, 43.864296, '长春动植物公园（动物互动+儿童乐园）'],
    [125.528192, 43.685738, '国信南山温泉（儿童戏水池+水上滑梯）'],
    [125.409845, 43.639662, '慢山里营地综合体（自然教育+亲子露营）'],
    [125.233844, 43.852538, '长春北湖国家湿地公园（观鸟+儿童科普步道）'],
    [125.306789, 43.856452, '南湖公园（免费儿童游乐区+划船）'],
    [125.542909, 43.882489, '卡伦湖旅游度假区（沙滩+水上项目）'],
    [125.584086, 43.878286, '长春冰雪新天地（冬季大型冰雪乐园）'],
    [125.307823, 43.882416, '吉林大学地质博物馆（恐龙化石互动展）']
];

var changchun = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default changchun